<template>
	<div>
		<div class="row" v-if="meta">
			<div class="offset-md-3 col-md-3 col-6 mt-2">
				<Multiselect 
					:options="meta.kotakabupaten.map(x => x.kode_kotakab)"
					:custom-label="opt => meta.kotakabupaten.find(x => x.kode_kotakab == opt).nama_kotakab"
					:allow-empty="true"
					placeholder="Select Kota  / Kabupaten"
					v-model="internalFilter.kotakab"
				/>
			</div>
			<div class="col-md-3 col-6 mt-2">
				<Multiselect 
					:options="meta.kecamatan.filter( x => x.kode_kotakab == internalFilter.kotakab).map(x => x.nama_kecamatan)"
					:allow-empty="true"
					:disabled="!internalFilter.kotakab"
					placeholder="Select Kecamatan"
					v-model="internalFilter.kecamatan"
				/>
			</div>
		</div>

		<div>
			<table class="table table-borderless text-center" v-if="reportData">
				<thead >
					<tr>
						<th rowspan="2">Kota</th>
						<th rowspan="2">Kecamatan</th>
						<th rowspan="2">Ring</th>
						<th colspan="2">Target</th>
						<th colspan="2">Actual</th>
						<th colspan="2">Gap</th>
						<th rowspan="2">% Cont. Kecamatan</th>
					</tr>
					<tr>
						<th>Unit</th>
						<th>% Contr</th>
						<th>Unit</th>
						<th>% Contr</th>
						<th>Unit</th>
						<th>% Contr</th>
					</tr>
					
				</thead>
				<tbody v-for="(data , index) in showData" :key="'Report' + index">
					<td>{{data.nama_kota}}</td>
					<td>{{data.nama_kecamatan}}</td>
					<td>{{data.ring}}</td>
					<td>{{data.target}}</td>
					<td>{{data.percent_contr_target}} %</td>
					<td>{{data.actual}}</td>
					<td>{{data.percent_contr_actual}} %</td>
					
					<td :style="{'color' : isNumeric(data.gap) ? parseFloat(data.gap) > 0 ? 'black' : 'red' : 'black'}">
						{{data.gap}}
					</td>
					<td :style="{'color' : isNumeric(data.percent_contr_gap) ? parseFloat(data.percent_contr_gap) > 0 ? 'black' : 'red' : 'black'}">
						{{data.percent_contr_gap}} %
					</td>
					<td>{{data.contr_kecamatan}} %</td>
				</tbody>
			</table>
		</div>

		<div class="mt-4 shadow rounded  pl-4 pr-4 pt-1 pb-4" v-if="summaryData">
			<h4 class="mt-3">Summary Data</h4>
			<table class="table table-borderless text-center">
				<thead >
					<tr>
						<th rowspan="2">Ring</th>
						<th colspan="2">Target</th>
						<th colspan="2">Actual</th>
						<th colspan="2">Gap</th>
					</tr>
					<tr>
						<th>Unit</th>
						<th>% Contr</th>
						<th>Unit</th>
						<th>% Contr</th>
						<th>Unit</th>
						<th>% Contr</th>
					</tr>
					
				</thead>
				<tbody v-for="(data , index) in summaryData" :key="'Summary' + index">
					<td>{{data.ring}}</td>
					<td>{{data.target}}</td>
					<td>{{data.percent_contr_target}} %</td>
					<td>{{data.actual}}</td>
					<td>{{data.percent_contr_actual}} %</td>
					<td :style="{'color' : isNumeric(data.gap) ? parseFloat(data.gap) > 0 ? 'black' : 'red' : 'black'}">
						{{data.gap}}
					</td>
					<td :style="{'color' : isNumeric(data.percent_contr_gap) ? parseFloat(data.percent_contr_gap) > 0 ? 'black' : 'red' : 'black'}">
						{{data.percent_contr_gap}} %
					</td>
				</tbody>
			</table>
		</div>


		
		

	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const XLSX = require('xlsx')
import moment from 'moment'
import { DatePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)

export default {
	components : {
		Multiselect,
		DatePicker
	},
	props : ['filter' , 'selected'],
	data () {
		let now = new moment()
		let month = now.month() + 1
		let year = now.year()


		return {
			modal : {
				uploadTarget : false,
				modifyModal : false
			},
			modalData : null,
			filterData : {
				dealer : this.$store.getters.getDealer(null , null)
			},
			internalFilter : {
				kotakab : null,
				kecamatan : null
			},
			reportData : null,
			summaryData : null,
			meta : null,
			showData : null
		}
	},
	watch : {
		
		filter : {
			deep : true,
			handler () {
				this.loadApi()
				console.log(this.filter)
			}
		},
		internalFilter : {
			deep : true,
			handler () {
				if(!this.internalFilter.kotakab)
					this.internalFilter.kecamatan = null

				if(!this.internalFilter.kotakab && !this.internalFilter.kecamatan)	
					this.showData = this.reportData

				
				let nama_kotakab = this.meta.kotakabupaten.find(x => x.kode_kotakab == this.internalFilter.kotakab).nama_kotakab
				this.showData = this.reportData.filter( x => x.nama_kota == nama_kotakab)

				if(this.internalFilter.kecamatan)
					this.showData = this.showData.filter(x => x.nama_kecamatan == this.internalFilter.kecamatan)

			}
		}
	},
	mounted () {
	},
	methods : {
		isNumeric(value) {
			return !isNaN(value)
		},
		exportExcel () {
			if(!this.reportData || !this.summaryData)
				return

			let wb = XLSX.utils.book_new()

			let reportJSON = this.reportData.map( x => ({
				"Kota" : x.nama_kota,
				"Kecamatan" : x.nama_kecamatan,
				"Ring" : x.ring,
				"Target" : x.target,
				"Target Contribution" : x.percent_contr_target + ' %',
				"Actual" : x.actual,
				"Actual Contribution" : x.percent_contr_actual + ' %',
				"Gap" : x.gap,
				"Gap Contribution" : x.percent_contr_gap + ' %',
				"Contribution Kecamatan" : x.contr_kecamatan + ' %'
			}))

			let reportSummary = this.summaryData.map( x => ({
				"Ring" : x.ring,
				"Target" : x.target,
				"Target Contribution" : x.percent_contr_target + ' %',
				"Actual" : x.actual,
				"Actual Contribution" : x.percent_contr_actual + ' %',
				"Gap" : x.gap,
				"Gap Contribution" : x.percent_contr_gap + ' %'
			}))

			let ws1 = XLSX.utils.json_to_sheet(reportJSON, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws1, "MCD Report")

			let ws2 = XLSX.utils.json_to_sheet(reportSummary, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws2, "Summary Report")

			XLSX.writeFile(wb, 'Dealer MCD Target.xlsx')
		},
		loadApi() {
			if(!this.filter.dealer) return

			let urlList = [{
				url : '/api/h1/report-mcd',
				var : 'reportData'
			}, {
				url : '/api/h1/report-mcd/summary',
				var : 'summaryData'
			}]


			for(var i = 0 ; i < urlList.length ; i++) {
				let curList = urlList[i]

				let filterStr = this.initialiseFilter('?' , this.filter)
				this.$http.get(curList.url + filterStr)
				.then((resp) => {
					let response = resp.data
					this[curList.var] = resp.data.data
					
					if(curList.var == 'reportData')
						this.showData = resp.data.data

					if(response.meta) {
						this.meta = response.meta
					}
				})
				.catch((err) => {
					console.log(err)
				})
			}
		}
	}
}
</script>

<style scoped>
	.text-red {
		color : red;
	}
	.text-green {
		color : green;
	}

	.btn-primary {
		background-color : #ff9700;
		border-color: #ff9700;
	}

	h4 {
		color : #707070;
	}
</style>

<style>
	.datePickerMCD .el-input__icon {
		margin-top : -1px;
	}
</style>